import { __extends } from "tslib";
import { ModuleRegistry, ReactLazyComponent } from 'react-module-container';
import { TRANSFER_DIALOG_COMPONENT_NAME, TRANSFER_DIALOG_LAZY_COMPONENT_NAME, DialogBundleNames } from '../config';
var minified = function (debug) { return (debug ? '' : '.min'); };
var TransferDialogLazyComponent = /** @class */ (function (_super) {
    __extends(TransferDialogLazyComponent, _super);
    function TransferDialogLazyComponent(props) {
        var _this = this;
        var siteActionsStaticsUrl = props.siteActionsStaticsUrl;
        if (props.topology && props.topology.siteActionsStaticsUrl) {
            // todo: tmp till i fix remove 'topology' from site settings
            siteActionsStaticsUrl = props.topology.siteActionsStaticsUrl;
        }
        _this = _super.call(this, props, {
            files: [
                "" + siteActionsStaticsUrl + DialogBundleNames.Transfer + ".bundle" + minified(props.debug) + ".js",
                "" + siteActionsStaticsUrl + DialogBundleNames.Transfer + minified(props.debug) + ".css"
            ],
            component: TRANSFER_DIALOG_COMPONENT_NAME
        }) || this;
        return _this;
    }
    return TransferDialogLazyComponent;
}(ReactLazyComponent));
export { TransferDialogLazyComponent };
ModuleRegistry.registerComponent(TRANSFER_DIALOG_LAZY_COMPONENT_NAME, function () { return TransferDialogLazyComponent; });
//# sourceMappingURL=transfer-dialog-lazy-component.js.map